export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10136.afc77100.jpg";